import {useEffect, useRef} from "react";
import {useAuthStore} from "@store/AuthStore";

function dismiss() {
    const {setOverlay, setOverlayMessage} = useAuthStore.getState();
    setOverlay(false);
    setOverlayMessage(null);
}

export function useDismissOverlayOnMount() {
    useEffect(() => {
        dismiss();

        const onPageShow = () => {
            dismiss();
        };

        const onVisibility = () => {
            if (document.visibilityState === "visible") dismiss();
        };

        window.addEventListener("pageshow", onPageShow);
        document.addEventListener("visibilitychange", onVisibility);

        return () => {
            window.removeEventListener("pageshow", onPageShow);
            document.removeEventListener("visibilitychange", onVisibility);
        };
    }, []);
}

export function useDebouncedEffect(
    effect: () => void,
    deps: any[],
    delayMs: number
) {
    const first = useRef(true);

    useEffect(() => {
        if (first.current) {
            first.current = false;
            effect();
            return;
        }

        const t = window.setTimeout(() => effect(), delayMs);
        return () => window.clearTimeout(t);
    }, [...deps, delayMs]);
}